/**
 * Enumeration representing test artifact states
 */
export enum TestArtifact {
  /** A test artifact */
  true,

  /** Not a test artifact */
  false
}
